import { CUSTOMER_JOURNEY_VENUES } from './../const';

function action(token, lang, context) {
  return { type: CUSTOMER_JOURNEY_VENUES, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyVenues.js